import Vue from 'vue'
import VueRouter from 'vue-router'
// import Users from '../views/Users.vue'
import SetFact from '../views/SetFact.vue'
import StatisticsView from '../views/StatisticsView.vue'
import ArchiveCalendar from '../views/ArchiveCalendar.vue'
import ArchiveView from '../views/ArchiveView.vue'
import NewsList from '../views/NewsList.vue'
import AccessoriesView from '../views/AccessoriesView.vue'
import ProductView from '../views/ProductView.vue'
import SubGroupView from '../views/SubGroupView.vue'
import BrigadesByDate from '../views/BrigadesByDate.vue'
import UserList from '../views/UserList.vue'
import PlanList from '../views/PlanList'
import PlanlistCopy from '../views/PlanlistCopy'
import BrigadesList from '../views/BrigadesList'
import Login from './../views/Login'
import Logout from './../views/Logout'
import SendPulse from './../views/SendPulse'

import RatesView from './../views/Rates.vue'
// Компоненты для микро приложения Рейтинги
import Rates from './../components/rates/Rates.vue'
import ShowRatesById from './../components/rates/show_by_id/ShowRatesById.vue'
import OrpList from './../components/rates/orp/OrpList.vue'
import ShowDepartment from './../views/ShowDepartment.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/rates'
  },
  {
    path: '/statistic',
    name: 'statistic',
    component: StatisticsView,
    title: 'Статистика'
  },
  {
    path: '/accessories',
    name: 'accessories',
    component: AccessoriesView,
  },
  {
    path: '/products',
    name: 'products',
    component: ProductView,
  },
  {
    path: '/sub_groups',
    name: 'sub_groups',
    component: SubGroupView,
  },
  {
    path: '/archive',
    name: 'archive',
    component: ArchiveCalendar,
    title: 'Архив'
  },
  {
    path: '/archive/:date',
    name: 'archive_by_date',
    component: ArchiveView,
    title: 'Архив'
  },
  {
    path: '/plans',
    name: 'plans',
    component: PlanList,
  },
  {
    path: '/plans/:date',
    name: 'plan',
    component: PlanlistCopy,
  },
  {
    path: '/set_fact',
    name: 'set_fact',
    component: SetFact,
  },
  {
    path: '/brigades',
    name: 'brigade',
    component: BrigadesList,
  },
  {
    path: '/brigades/:date',
    name: 'brigadesDate',
    component: BrigadesByDate,
  },
  {
    path: '/news',
    name: 'news',
    component: NewsList,
  },
  {
    path: '/users',
    name: 'users',
    component: UserList,
  },
  {
    path: '/rates',
    component: RatesView,
    children: [
      {
        path: '',
        component: Rates
      },
      {
        path: 'orp',
        component: OrpList
      },
      {
        path: 'orp/:id',
        component: ShowDepartment
      },
      {
        path: ':id',
        component: ShowRatesById
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout,
  },

  {
    path: '/send-pulse',
    name: 'send-pulse',
    component: SendPulse,
  },


];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router